import { Clickable, H2, H3, List, P, Section, Strong } from '@ahmdigital/ui';

import config from '../../../../../config';
import constants from '../../../../../ahm-constants';
import styles from '../styles.module.sass';

const STATIC_DOMAIN = config.get('static:url');

const FormsAndGuides = () => (
  <Section id="formsAndGuides" className={styles.section}>
    <H2 variant="marginBottomSpacer10">Forms and guides</H2>

    <P>
      The below are issued on or before 30 June 2023. If you can’t find the documents you need below or are unsure which
      ones are relevant to your policy, please contact us for assistance.
    </P>
    <P>
      <Strong>Important notice:</Strong> Effective 1 December 2025, policies previously issued by Swiss Re Life & Health
      Australia Limited ABN 74 000 218 306, AFSL 324908 (Swiss Re) have now transferred to Hannover Life Re of
      Australasia Ltd ABN 37 062 395 484, AFSL 530811 (Hannover).
    </P>

    <H3 looksLike="h4">Product Disclosure Statements</H3>
    <P>
      The Product Disclosure Statement provides detail on the key features, benefits, exclusions, terms and conditions
      of the relevant policy.
    </P>
    <List className={styles.list}>
      <li>
        <Clickable inNewTab to={`${STATIC_DOMAIN}/files/life-insurance/ahm-life-insurance-pds.pdf`}>
          ahm life insurance product disclosure statement
        </Clickable>{' '}
        (effective 27/09/2021)
      </li>
      <li>
        <Clickable inNewTab to={`${STATIC_DOMAIN}/files/life-insurance/ahm-life-insurance-express-pds.pdf`}>
          ahm life insurance express product disclosure statement
        </Clickable>{' '}
        (effective 27/09/2021)
      </li>
    </List>

    <H3 looksLike="h4">Significant Event Notices</H3>
    <P>
      Significant event notices provide important information relating to updates or changes that may affect your
      policy.
    </P>
    <List className={styles.list}>
      <li>
        <Clickable
          inNewTab
          to={`${STATIC_DOMAIN}/files/life-insurance/ahm-life-insurance-significant-event-notice-2024.pdf`}
        >
          ahm life insurance product upgrade brochure
        </Clickable>{' '}
        (effective from 9/11/2023) – This product upgrade brochure is applicable to policy holders with a policy start
        date on and between 03/08/2018 – 01/07/2023.
      </li>
    </List>

    <H3 looksLike="h4">Key Fact Sheets</H3>
    <List className={styles.list}>
      <li>
        <Clickable inNewTab to={`${STATIC_DOMAIN}/files/life-insurance/ahm-life-insurance-kfs.pdf`}>
          ahm life insurance key fact sheet
        </Clickable>
      </li>
      <li>
        <Clickable inNewTab to={`${STATIC_DOMAIN}/files/life-insurance/ahm-life-insurance-express-kfs.pdf`}>
          ahm life insurance express key fact sheet
        </Clickable>
      </li>
    </List>

    <H3 looksLike="h4">Financial Services Guide</H3>
    <P>
      The Financial Services Guide contains information about who is providing you with the financial services. It
      explains the financial service offered, the fees charged and how we will deal with complaints.
    </P>
    <List className={styles.list}>
      <li>
        <Clickable inNewTab to={`${STATIC_DOMAIN}/files/life-insurance/ahm-financial-services-guide.pdf`}>
          ahm life insurance financial services guide
        </Clickable>
      </li>
    </List>

    <H3 looksLike="h4">Target Market Determination</H3>
    <List className={styles.list}>
      <li>
        <Clickable inNewTab to={`${STATIC_DOMAIN}/files/life-insurance/ahm-life-insurance-tmd.pdf`}>
          ahm Life Insurance Target Market determination
        </Clickable>{' '}
        (effective 27/09/2021)
      </li>
      <li>
        <Clickable inNewTab to={`${STATIC_DOMAIN}/files/life-insurance/ahm-life-insurance-express-tmd.pdf`}>
          ahm Life Insurance Express Target Market determination
        </Clickable>{' '}
        (effective 27/09/2021)
      </li>
    </List>
    <P>
      References made in the above Product Disclosure Statements, Significant Event Notices, Financial Services Guide,
      Target Market Determination and Key Fact Sheets to:
    </P>
    <List className={styles.list}>
      <li>‘Swiss Re Life & Health Australia Limited ABN 74 000 218 306, AFSL 324908’ and</li>
      <li>’Swiss Re’</li>
    </List>
    <P>should now be read as ‘Hannover Life Re of Australasia Ltd ABN 37 062 395 484, AFSL 530811 (Hannover)’.</P>
    <P>
      Hannover encourages customers to read{' '}
      <Clickable to={constants.URLS.THIRD_PARTY.HANNOVER_RE_PRIVACY_POLICY}>Hannover’s Privacy Policy</Clickable> to
      understand how Hannover collects, holds, uses and discloses their personal information.
    </P>

    <H3 looksLike="h4">Duty to take reasonable care</H3>
    <List className={styles.list}>
      <li>
        <Clickable inNewTab to={constants.URLS.HELP.DUTY_TO_TAKE_REASONABLE_CARE}>
          Duty to take reasonable care
        </Clickable>
      </li>
    </List>

    <H3 looksLike="h4">Forms</H3>
    <List className={styles.list}>
      <li>
        <Clickable inNewTab to={`${STATIC_DOMAIN}/files/life-insurance/ahm-nomination-of-beneficiary-form.pdf`}>
          ahm nomination of beneficiaries form
        </Clickable>
      </li>
    </List>
  </Section>
);

export default FormsAndGuides;
